import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeft, Lock, LogIn, UserPlus } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export const Route = createFileRoute('/401')({
  component: UnauthorizedPage,
  staticData: {
    status: 401,
  },
})

function UnauthorizedPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-muted/30 flex items-center justify-center p-4 md:p-8">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-amber-500/10 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 w-full max-w-lg">
        <Card className="border-none shadow-2xl bg-card/80 backdrop-blur-sm">
          <CardHeader className="text-center pb-2">
            <div className="mx-auto mb-6 p-4 rounded-full bg-amber-500/10">
              <Lock className="w-12 h-12 text-amber-500" />
            </div>
            <CardTitle className="text-3xl md:text-4xl font-bold tracking-tight">
              Unauthorized
            </CardTitle>
            <CardDescription className="text-lg mt-2">Access Denied</CardDescription>
          </CardHeader>
          <CardContent className="text-center space-y-6 pt-4">
            <p className="text-muted-foreground text-sm md:text-base leading-relaxed">
              Sorry, you don't have permission to access this page. This area is restricted to
              authorized personnel only.
            </p>

            <div className="bg-muted/50 rounded-lg p-4 text-sm">
              <p className="text-muted-foreground">
                If you believe this is an error, please contact your administrator or try logging in
                with different credentials.
              </p>
            </div>

            <div className="pt-4 flex flex-col gap-3 sm:flex-row items-center justify-center">
              <Button asChild>
                <Link to="/login">
                  <LogIn className="w-4 h-4 mr-2" />
                  Sign In
                </Link>
              </Button>
              <Button variant="outline" asChild>
                <Link to="/register">
                  <UserPlus className="w-4 h-4 mr-2" />
                  Create Account
                </Link>
              </Button>
            </div>

            <div className="pt-4">
              <Button variant="ghost" onClick={() => window.history.back()}>
                <ArrowLeft className="w-4 h-4 mr-2" />
                Go Back
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
